const coin = {};

const pearl = {
  amountPlaceholder: 'Enter the amount to send',
};

export default {
  shippingCoin: 'Shipping Coin',
  level: 'LV{{num}}',
  pearl2coins: '{{pearl}}Pearl = {{coin}}Coins',
  confirmTips: 'Please check the ID and amount you want to send',
  inputAmountTips: 'Enter the amount to send',
  resultTitle: 'For coin',
  successTitle: 'Send successfully',
  successContent:
    'The recipient has received the coins and will receive a message automatically sent by you',
  failureContent:
    'The current transaction is abnormal, please go to the transaction details to verify the result',
  pearlConfirmTips: 'Please check the amount you want to exchange(Pearl Balance {{num}})',
  coin,
  pearl,
};
